import { render, staticRenderFns } from "./email_verification.vue?vue&type=template&id=33514ce8"
import script from "./email_verification.vue?vue&type=script&lang=js"
export * from "./email_verification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports